module.exports = __webpack_public_path__ + "img/not-team-header-bg.036ba72c.png";